import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../../../config/site';
import styles from './Footer.module.css';

export function Footer() {
  const logoRef = useRef(null);
  const [logoWidth, setLogoWidth] = useState(undefined);

  useEffect(() => {
    const logo = logoRef.current;
    if (!logo) return;

    const updateWidth = () => setLogoWidth(logo.offsetWidth);
    updateWidth();

    const observer = new ResizeObserver(updateWidth);
    observer.observe(logo);
    return () => observer.disconnect();
  }, []);

  return (
    <footer className={styles.footer}>
      <div className="container">
        <p className={styles.description}>{SITE.description}</p>

        <div className={styles.main}>
          <div className={styles.brand}>
            <Link to="/" ref={logoRef} className={styles.logo}>
              <img src="/logo.png" alt={`${SITE.brandName} — товары для кондитеров в ${SITE.city}е`} className={styles.logoImage} />
            </Link>
            <p className={styles.tagline}>{SITE.tagline}</p>
            <div
              className={styles.ratingWrap}
              style={logoWidth ? { width: logoWidth } : undefined}
            >
              <iframe
                src={SITE.yandexRatingBadgeUrl}
                title="Рейтинг на Яндекс"
                frameBorder="0"
                className={styles.ratingBadge}
              />
            </div>
            <div className={styles.socialBlock}>
              <p className={styles.socialTitle}>Социальные сети</p>
              <a
                href={SITE.vkUrl}
                className={styles.social}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="ВКонтакте"
              >
                vk
              </a>
            </div>
          </div>

          <div className={styles.contacts}>
            <h3 className={styles.contactsTitle}>Контакты</h3>
            <dl className={styles.contactsList}>
              <div className={styles.contactItem}>
                <dt>Адрес</dt>
                <dd>
                  <a href={SITE.mapsUrl} target="_blank" rel="noopener noreferrer">
                    {SITE.address}
                  </a>
                </dd>
              </div>
              <div className={styles.contactItem}>
                <dt>Телефон</dt>
                <dd>
                  <a href={`tel:${SITE.phone.replace(/\D/g, '')}`}>{SITE.phone}</a>
                </dd>
              </div>
              <div className={styles.contactItem}>
                <dt>Режим работы</dt>
                <dd>{SITE.hours}</dd>
              </div>
              <div className={styles.contactItem}>
                <dt>Эл. почта</dt>
                <dd>
                  <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
                </dd>
              </div>
            </dl>
          </div>
        </div>

        <div className={styles.legal}>
          <span>{SITE.legalName}</span>
          <Link to="/retail-store">Розничный магазин</Link>
          <Link to="/delivery">Доставка</Link>
          <Link to="/food-printing">Пищевая печать</Link>
          <Link to="/studio">Студия</Link>
        </div>
      </div>
    </footer>
  );
}
